import React from 'react';
import TextMarquee from '../common/TextMarquee';
import {beneficiaries} from '../../data/beneficiaries';

const BeneficiaryScroll = () => {
	return (
		<section id="beneficiary-names">
			<TextMarquee list={beneficiaries.slice(0, 5)} direction="left" />
			<TextMarquee list={beneficiaries.slice(5, 10)} direction="right" />
			<TextMarquee list={beneficiaries.slice(10, 15)} direction="left" />
			<TextMarquee list={beneficiaries.slice(15, 20)} direction="right" />
		</section>
	);
};

export default BeneficiaryScroll;
